export const HEADERS = {
  HELP_CENTRAL: 'Central de Ajuda',
  QUICK_SOLUTIONS: 'Quero contatar o SAC',
  NEW_REQUEST: 'Quero contatar o SAC',
  EXISTING_CUSTOMER: 'Sou cliente',
  NON_CUSTOMER: 'Não sou cliente',
  WHAT_HAPPENED: 'O que aconteceu?',
}
